import { render } from "./PlayerDetail.vue?vue&type=template&id=714dab39&scoped=true"
import script from "./PlayerDetail.vue?vue&type=script&lang=js"
export * from "./PlayerDetail.vue?vue&type=script&lang=js"

import "./PlayerDetail.vue?vue&type=style&index=0&id=714dab39&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-714dab39"]])

export default __exports__